export default "__VITE_ASSET__DalATSJM__"